import { useMutation, useQueryClient } from "react-query";

import axios, { AxiosError } from "axios";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../../constants/app.constants";
import { RingFenceResponse } from "../../models/ringFence";
import {
  GetAllRingFencesKey,
  GetRingFenceKey,
  GetRingFencesByScenarioKey
} from "./constants";

const API_URL = `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/ring-fence`;

interface DeleteRingFenceParams {
  ringFenceId: string;
  scenarioId?: string; // Optional for cache invalidation
}

const deleteRingFence = async ({
  ringFenceId
}: DeleteRingFenceParams): Promise<RingFenceResponse> => {
  const response = await axios.delete<RingFenceResponse>(`${API_URL}/${ringFenceId}`);
  return response.data;
};

const useDeleteRingFence = () => {
  const queryClient = useQueryClient();

  return useMutation<RingFenceResponse, AxiosError, DeleteRingFenceParams, unknown>(
    deleteRingFence,
    {
      onSuccess: async (data, variables) => {
        // Invalidate related queries
        await queryClient.invalidateQueries([GetRingFenceKey, variables.ringFenceId]);
        await queryClient.invalidateQueries(GetAllRingFencesKey);

        // If scenario ID is provided, invalidate the scenario-specific query
        if (variables.scenarioId) {
          await queryClient.invalidateQueries([
            GetRingFencesByScenarioKey,
            variables.scenarioId
          ]);
        }
      }
    }
  );
};

export default useDeleteRingFence;
